export default {
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',

  'menu.dashboard': '仪表盘',
  'menu.dashboard.analysis': '分析页',

  'menu.device': '设备管理',
  'menu.device.deviceList': '设备列表',

  'menu.event': '事件日志',
  'menu.event.deviceList': '设备事件',
  'menu.event.commandList': '指令事件',
  'menu.event.ssfLog': 'SSF 推送日志',

  'menu.business': '企业管理',
  'menu.business.businessInfo': '企业信息',
  'menu.business.businessInfo.baseInfo': '基本信息',
  'menu.business.businessInfo.requestCertificate': '申请证书',
  'menu.business.businessInfo.enrollmentSettings': '注册设置',
  'menu.business.certificate': '证书管理',
  'menu.business.certificate.operation': '操作',
  'menu.business.certificate.discussion': '讨论',
  'menu.business.managedAppleId': 'Managed Apple ID',

  'menu.other': '其他',
  'menu.other.otherMedia': '媒体文件',
  'menu.other.otherAsset': '资源管理',

  'menu.account': '个人中心',
  'menu.account.settings': '安全设置',
  'menu.account.logout': '退出登录',

  'menu.systemSettings': '系统设置',
  'menu.systemSettings.center': '用户管理',
  'menu.systemSettings.s3Storage': 'S3 存储',
  'menu.systemSettings.smtp': 'SMTP',
  'menu.systemSettings.platformBackup': '平台备份',
  'menu.systemSettings.oidcApp': 'OIDC 应用',
};
